import React, { useState } from "react";
import { Accordion, Button, Col, Container, Row } from "react-bootstrap";
// css
import styles from "./ClientDetail.module.scss";
import { Link, useParams } from "react-router-dom";

// img
import p1 from "../../../../Assets/images/user.png";
// import formIcn from "../../../../Assets/images/formIcn.svg";
import { useGetChatterProgramAttendanceDetailsQuery, useGetChatterProgramDetailsQuery, useMarkAttendanceMutation, useRemoveAssignedLessonMutation } from "store/services/chatterPrograms";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { convertToMomentDate, convertToMomentTime, successMessageToast, userFullName } from "helpers/common";
import { CommonToolTip } from "components/Common/Common";
import { DeleteIcon } from "Assets/icons";
import ShowAttachedFilesPop from "components/Modals/ViewAttachedFilesPop";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import LoadingOverlay from "components/shared/LoadingOverlay";
import AddChatterLessonPop from "components/Modals/AddLessonPop";
import { ProgramDetailsAccordion } from "./ProgramDetailsAccordion";
import moment from "moment";
const ChatterEventAttendanceDetail = () => {


  const { id: clientId } = useParams();
  const { data, isLoading, isFetching } = useGetChatterProgramAttendanceDetailsQuery(clientId);
  // const clientDetails = data?.records?.[0]

  const [tableRow, setTableRow] = useState(false);

  const [markAttendance, { isLoading: markAttendanceLoading }] = useMarkAttendanceMutation();


  const handleAttendance = async (id, data) => {
    try {

      if (!markAttendanceLoading && !isFetching) {
        const result = await markAttendance({ id, data });
        if (!result?.error) successMessageToast(result?.data?.message);
      }

    } catch (err) {
      console.error("error mark attendance", err);
    };
  };

  const defaultActiveKeys = data?.records?.map((_, index) => index.toString())

  return (
    <>
      <section
        className={`${styles.ClientDetail} position-relative ClientDetail`}
      >
        <Container fluid>
          {isLoading ? <LoadingIndicator /> : <Row>
            <Col
              lg="6"
              className=""
              style={{ borderRight: "1px solid #3da0aa4f" }}
            >
              {(isFetching || markAttendanceLoading) && <LoadingOverlay />}

              {/* <Row>
                <Col lg="12" className="my-3">
                  <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                    <div className="left">
                      <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                        <li className="">
                          <h6 className="m-0 themeBlue fw-bold text-capitalize">

                            {clientDetails?.name || "--"}
                          </h6>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Col>
                <Col lg="12" className="my-3">
                  <Row>
                    <Col md="4" sm="6" className="my-2">
                      <div className="cardCstm p-3 bg-white clint-profile-detail h-100 common-border-radius">
                        <h6 className="m-0 themeBlue fw-bold">
                          {" "}
                          <span className="" style={{ color: "#3DA0AA" }}>
                            ■
                          </span>{" "}
                          Start Date
                        </h6>
                        <p className="m-0 themeBlue pt-3 lh-1">{clientDetails?.start_date ? convertToMomentDate(clientDetails?.start_date) : "--"}</p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <div className="cardCstm p-3 bg-white clint-profile-detail h-100 common-border-radius">
                        <h6 className="m-0 themeBlue fw-bold">
                          {" "}
                          <span className="" style={{ color: "#3DA0AA" }}>
                            ■
                          </span>{" "}
                          End Date
                        </h6>
                        <p className="m-0 themeBlue pt-3 lh-1">{clientDetails?.end_date ? convertToMomentDate(clientDetails?.end_date) : "--"}</p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <div className="cardCstm p-3 bg-white clint-profile-detail h-100 common-border-radius">
                        <h6 className="m-0 themeBlue fw-bold">
                          {" "}
                          <span className="" style={{ color: "#3DA0AA" }}>
                            ■
                          </span>{" "}
                          Day
                        </h6>
                        <p className="m-0 themeBlue pt-3 lh-1 text-capitalize">{clientDetails?.day || ""}</p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <div className="cardCstm p-3 bg-white clint-profile-detail h-100 common-border-radius">
                        <h6 className="m-0 themeBlue fw-bold">
                          {" "}
                          <span className="" style={{ color: "#3DA0AA" }}>
                            ■
                          </span>{" "}
                          Start Time
                        </h6>
                        <p className="m-0 themeBlue pt-3 lh-1">{clientDetails?.time ? convertToMomentTime(clientDetails?.time) : "--"}</p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <div className="cardCstm p-3 bg-white clint-profile-detail h-100 common-border-radius">
                        <h6 className="m-0 themeBlue fw-bold">
                          {" "}
                          <span className="" style={{ color: "#3DA0AA" }}>
                            ■
                          </span>{" "}
                          Location
                        </h6>
                        <p className="m-0 themeBlue pt-3 lh-1 text-capitalize">{clientDetails?.location || "--"}</p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <div className="cardCstm p-3 bg-white clint-profile-detail h-100 common-border-radius">
                        <h6 className="m-0 themeBlue fw-bold">
                          {" "}
                          <span className="" style={{ color: "#3DA0AA" }}>
                            ■
                          </span>{" "}
                          Funding Source
                        </h6>
                        <p className="m-0 themeBlue pt-3 lh-1">{clientDetails?.program_funding_source?.name || "--"}</p>
                      </div>
                    </Col>

                    <Col md="4" sm="6" className="my-2">
                      <div className="cardCstm p-3 bg-white clint-profile-detail h-100 common-border-radius">
                        <h6 className="m-0 themeBlue fw-bold">
                          {" "}
                          <span className="" style={{ color: "#3DA0AA" }}>
                            ■
                          </span>{" "}
                          Location Type
                        </h6>
                        <p className="m-0 themeBlue pt-3 lh-1 text-capitalize">{clientDetails?.location_type || "--"}</p>
                      </div>
                    </Col>

                  </Row>

                  <Row>
                    <Col md="4" className="my-2">
                      <div className="cardCstm p-3 bg-white clint-profile-detail group-leader-wrapper h-100">
                        <h6 className="m-0 themeBlue fw-bold">
                          {" "}
                          <span className="" style={{ color: "#3DA0AA" }}>
                            ■
                          </span>{" "}
                          Group Leader 1
                        </h6>
                        <div className=" d-flex gap-2 pt-3 imgWrp align-items-center flex-shrink-0">
                          <img
                            src={p1}
                            alt=""
                            className="img-fluid rounded-circle object-fit-cover"
                            style={{ height: 30, width: 30 }}
                          />
                          <p className="m-0 themeBlue lh-1  text-capitalize">{clientDetails?.program_head_one ? userFullName(clientDetails?.program_head_one) : "--"}</p>
                        </div>
                      </div>
                    </Col>
                    <Col md="4" className="my-2">
                      <div className="cardCstm p-3 bg-white clint-profile-detail group-leader-wrapper h-100">
                        <h6 className="m-0 themeBlue fw-bold">
                          {" "}
                          <span className="" style={{ color: "#3DA0AA" }}>
                            ■
                          </span>{" "}
                          Group Leader 2
                        </h6>
                        <div className=" d-flex gap-2 pt-3 imgWrp align-items-center flex-shrink-0">
                          <img
                            src={p1}
                            alt=""
                            className="img-fluid rounded-circle object-fit-cover"
                            style={{ height: 30, width: 30 }}
                          />
                          <p className="m-0 themeBlue lh-1  text-capitalize">{clientDetails?.program_head_two ? userFullName(clientDetails?.program_head_two) : "--"}</p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row> */}
            </Col>
            {/* <Col lg="6" className="">
              <Row>
                <Col lg="12" className="my-2">
                  <div className="d-flex align-items-center justify-content-between flex-wrap gap-10">
                    <h6 className="m-0 themeBlue fw-sbold">Track Attendence</h6>
                  </div>
                </Col>
                <Col lg="12" className="my-2">
                  <p className="m-0 d-flex  align-items-center fw-sbold py-2">
                    Event Date
                  </p>
                  <div
                    className={`${styles.tableResponsive} tableResponsive table-responsive border rounded-2 mb-3 pb-0`}
                  >
                    <table className={`${styles.table} table mb-0`}>
                      {
                        clientDetails?.attendance?.map((item, index) => {
                          return <tbody>
                            <tr onClick={() => setTableRow(tableRow == index ? null : index)}>
                              <td className="">{convertToMomentDate(item?.session_date)}</td>

                              <td className="">
                                <Button
                                  className="border-0 p-0"
                                  variant="transparent"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                  >
                                    <path
                                      d="M10 7.26925L6.4615 10.8078L13.5385 10.8078L10 7.26925ZM9.99825 0.500001C11.3122 0.500001 12.5473 0.749333 13.7035 1.248C14.8597 1.74667 15.8653 2.42342 16.7205 3.27825C17.5757 4.13308 18.2527 5.13833 18.7517 6.294C19.2506 7.44967 19.5 8.68442 19.5 9.99825C19.5 11.3123 19.2507 12.5473 18.752 13.7035C18.2533 14.8597 17.5766 15.8653 16.7217 16.7205C15.8669 17.5757 14.8617 18.2528 13.706 18.7518C12.5503 19.2506 11.3156 19.5 10.0017 19.5C8.68775 19.5 7.45267 19.2507 6.2965 18.752C5.14033 18.2533 4.13467 17.5766 3.2795 16.7218C2.42433 15.8669 1.74725 14.8617 1.24825 13.706C0.749416 12.5503 0.499999 11.3156 0.499999 10.0018C0.499999 8.68775 0.749331 7.45267 1.248 6.2965C1.74666 5.14033 2.42341 4.13467 3.27825 3.2795C4.13308 2.42433 5.13833 1.74725 6.294 1.24825C7.44966 0.749417 8.68442 0.500001 9.99825 0.500001ZM10 2C7.76666 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2Z"
                                      fill="#071E3E"
                                    />
                                  </svg>
                                </Button>
                              </td>
                            </tr>
                            {tableRow == index ? (
                              <tr>
                                <td colSpan={4} className="p-0 border-0">
                                  <div
                                    className={`${styles.tableResponsive} tableResponsive table-responsive mb-0 pb-0`}
                                  >
                                    <table className={`${styles.table} table mb-0`}>
                                      <thead>
                                        <tr className="">
                                          <th className="text-dark fw-bold bg-transparent">
                                            USERS
                                          </th>
                                          <th className="text-dark fw-bold bg-transparent">
                                            PRESENT/ABSENT
                                          </th>
                                          <th className="text-dark fw-bold bg-transparent">
                                            PARENT
                                          </th>
                                        </tr>
                                      </thead>
                                      {
                                        clientDetails?.programMembers?.map((member, ind) => {

                                          const userAttendance = item?.attendance?.find(x => x.member_id == member.id);
                                          return <tbody key={ind}>
                                            <tr>
                                              <td className="border-0 p-2 text-capitalize">
                                                {userFullName(member?.programMember)}
                                              </td>
                                              <td className="border-0 p-2">
                                                <span>
                                                  {userAttendance?.attendance == "present" ? <PresentIcon /> : <AbsentIcon />}
                                                </span>
                                              </td>
                                              <td className="border-0 p-2">
                                                <td className="border-0 p-2">
                                                  <span >
                                                    {userAttendance?.with_parent == "yes" ? <PresentIcon /> : <AbsentIcon />}
                                                  </span>
                                                </td></td>
                                            </tr>
                                          </tbody>
                                        })
                                      }
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            ) : null}
                          </tbody>
                        })
                      }
                    </table>
                  </div>
                </Col>
              </Row>
            </Col> */}
            <Col lg="12" className="my-3">
              <Row>
                <Col md="3" className="my-2">
                  <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                    <h6 className="m-0 themeBlue fw-bold">
                      {" "}
                      <span className="" style={{ color: "#3DA0AA" }}>
                        ■
                      </span>{" "}
                      Last Name
                    </h6>
                    <p className="m-0 forteen themeBlue pt-2">{data?.memberDetails?.lastname || "--"}</p>
                  </div>
                </Col>
                <Col md="3" className="my-2">
                  <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                    <h6 className="m-0 themeBlue fw-bold">
                      {" "}
                      <span className="" style={{ color: "#3DA0AA" }}>
                        ■
                      </span>{" "}
                      First Name
                    </h6>
                    <p className="m-0 forteen themeBlue pt-2">{data?.memberDetails?.firstname || "--"}</p>
                  </div>
                </Col>
                <Col md="4" sm="6" className="my-2">
                  <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                    <h6 className="m-0 themeBlue fw-bold">
                      {" "}
                      <span className="" style={{ color: "#3DA0AA" }}>
                        ■
                      </span>{" "}
                      DOB
                    </h6>
                    <p className="m-0 forteen themeBlue pt-2">{data?.memberDetails?.client_detail?.dob ? moment(data?.memberDetails?.client_detail?.dob).format("DD/MM/YYYY") : "--"}</p>
                  </div>
                </Col>
                <Col md="6" className="my-2">
                  <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                    <h6 className="m-0 themeBlue fw-bold">
                      {" "}
                      <span className="" style={{ color: "#3DA0AA" }}>
                        ■
                      </span>{" "}
                      Address
                    </h6>
                    <p className="m-0 forteen themeBlue pt-2">{data?.memberDetails?.client_detail?.address || "--"}</p>
                  </div>
                </Col>
                {
                  data?.memberDetails?.client_detail?.client_type == 'peer' &&
                  <Col md="4" sm="6" className="my-2">
                    <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                      <h6 className="m-0 themeBlue fw-bold">
                        {" "}
                        <span className="" style={{ color: "#3DA0AA" }}>
                          ■
                        </span>{" "}
                        Phone
                      </h6>
                      <p className="m-0 forteen themeBlue pt-2">{data?.memberDetails?.phone || "--"}</p>
                    </div>
                  </Col>
                }
                <Col md="4" sm="6" className="my-2">
                  <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                    <h6 className="m-0 themeBlue fw-bold">
                      {" "}
                      <span className="" style={{ color: "#3DA0AA" }}>
                        ■
                      </span>{" "}
                      City/Town
                    </h6>
                    <p className="m-0 forteen themeBlue pt-2">{data?.memberDetails?.client_detail?.city_town || "--"}</p>
                  </div>
                </Col>
                {data?.memberDetails?.allPrograms?.length > 0 && (
                  <Col md="6" sm="6" className="my-2">
                    <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                      <h6 className="m-0 themeBlue fw-bold">
                        {" "}
                        <span className="" style={{ color: "#3DA0AA" }}>
                          ■
                        </span>{" "}
                        Group Assigned To
                      </h6>
                      <ul className="pt-2">
                        {data?.memberDetails?.allPrograms.map((program, index) => (
                          <li key={index}>
                            <p className="m-0 forteen themeBlue">{program?.name || "--"}</p>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </Col>
                )}

                {
                  data?.memberDetails?.client_detail?.client_type == 'peer' &&
                  <Col md="6" sm="6" className="my-2">
                    <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                      <h6 className="m-0 themeBlue fw-bold">
                        {" "}
                        <span className="" style={{ color: "#3DA0AA" }}>
                          ■
                        </span>{" "}
                        Email
                      </h6>
                      <p className="m-0 forteen themeBlue pt-2" style={{ wordWrap: "break-word" }}>{data?.memberDetails?.email || "--"}</p>
                    </div>
                  </Col>
                }
              </Row>
            </Col>
            <Col lg="12" className="my-3">
              <Accordion defaultActiveKey={defaultActiveKeys} alwaysOpen>
                {
                  data?.records?.map((client, index) =>
                    <Accordion.Item key={index} eventKey={index.toString()}>
                      <Accordion.Header className='staff-client-accordion'>
                        <div className='d-flex aalign-items-center justify-content-between w-100 align-items-center'>
                          <div>
                            <div className='mb-2'>
                              <span style={{ fontWeight: "bold", fontSize: "16px" }}>Program Name: </span>{client?.name}
                            </div>
                          </div>
                          <div style={{ marginRight: "10px" }}>
                            <div className='mb-2'>
                              <span style={{ fontWeight: "bold", fontSize: "16px" }}>Total Sessions:</span> {client?.totalsession}
                            </div>
                            <div>
                              <span style={{ fontWeight: "bold", fontSize: "16px" }}>Attended Sessions:</span> {client?.totalpresent}
                            </div>
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <Row>
                          <Col
                            lg="6"
                            className=""
                            style={{ borderRight: "1px solid #3da0aa4f" }}
                          >
                            {(isFetching || markAttendanceLoading) && <LoadingOverlay />}

                            <Row>
                              <Col lg="12" className="my-3">
                                <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                                  <div className="left">
                                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                                      <li className="">
                                        <h6 className="m-0 themeBlue fw-bold text-capitalize">

                                          {/* {client?.name || "--"} */}
                                        </h6>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </Col>
                              <Col lg="12" className="my-3">
                                <Row>
                                  <Col md="4" sm="6" className="my-2">
                                    <div className="cardCstm p-3 bg-white clint-profile-detail h-100 common-border-radius">
                                      <h6 className="m-0 themeBlue fw-bold">
                                        {" "}
                                        <span className="" style={{ color: "#3DA0AA" }}>
                                          ■
                                        </span>{" "}
                                        Start Date
                                      </h6>
                                      <p className="m-0 themeBlue pt-3 lh-1">{client?.start_date ? convertToMomentDate(client?.start_date) : "--"}</p>
                                    </div>
                                  </Col>
                                  <Col md="4" sm="6" className="my-2">
                                    <div className="cardCstm p-3 bg-white clint-profile-detail h-100 common-border-radius">
                                      <h6 className="m-0 themeBlue fw-bold">
                                        {" "}
                                        <span className="" style={{ color: "#3DA0AA" }}>
                                          ■
                                        </span>{" "}
                                        End Date
                                      </h6>
                                      <p className="m-0 themeBlue pt-3 lh-1">{client?.end_date ? convertToMomentDate(client?.end_date) : "--"}</p>
                                    </div>
                                  </Col>
                                  <Col md="4" sm="6" className="my-2">
                                    <div className="cardCstm p-3 bg-white clint-profile-detail h-100 common-border-radius">
                                      <h6 className="m-0 themeBlue fw-bold">
                                        {" "}
                                        <span className="" style={{ color: "#3DA0AA" }}>
                                          ■
                                        </span>{" "}
                                        Day
                                      </h6>
                                      <p className="m-0 themeBlue pt-3 lh-1 text-capitalize">{client?.day || ""}</p>
                                    </div>
                                  </Col>
                                  <Col md="4" sm="6" className="my-2">
                                    <div className="cardCstm p-3 bg-white clint-profile-detail h-100 common-border-radius">
                                      <h6 className="m-0 themeBlue fw-bold">
                                        {" "}
                                        <span className="" style={{ color: "#3DA0AA" }}>
                                          ■
                                        </span>{" "}
                                        Start Time
                                      </h6>
                                      <p className="m-0 themeBlue pt-3 lh-1">{client?.time ? convertToMomentTime(client?.time) : "--"}</p>
                                    </div>
                                  </Col>
                                  <Col md="4" sm="6" className="my-2">
                                    <div className="cardCstm p-3 bg-white clint-profile-detail h-100 common-border-radius">
                                      <h6 className="m-0 themeBlue fw-bold">
                                        {" "}
                                        <span className="" style={{ color: "#3DA0AA" }}>
                                          ■
                                        </span>{" "}
                                        Location
                                      </h6>
                                      <p className="m-0 themeBlue pt-3 lh-1 text-capitalize">{client?.location || "--"}</p>
                                    </div>
                                  </Col>
                                  <Col md="4" sm="6" className="my-2">
                                    <div className="cardCstm p-3 bg-white clint-profile-detail h-100 common-border-radius">
                                      <h6 className="m-0 themeBlue fw-bold">
                                        {" "}
                                        <span className="" style={{ color: "#3DA0AA" }}>
                                          ■
                                        </span>{" "}
                                        Funding Source
                                      </h6>
                                      <p className="m-0 themeBlue pt-3 lh-1">{client?.program_funding_source?.name || "--"}</p>
                                    </div>
                                  </Col>

                                  <Col md="4" sm="6" className="my-2">
                                    <div className="cardCstm p-3 bg-white clint-profile-detail h-100 common-border-radius">
                                      <h6 className="m-0 themeBlue fw-bold">
                                        {" "}
                                        <span className="" style={{ color: "#3DA0AA" }}>
                                          ■
                                        </span>{" "}
                                        Location Type
                                      </h6>
                                      <p className="m-0 themeBlue pt-3 lh-1 text-capitalize">{client?.location_type || "--"}</p>
                                    </div>
                                  </Col>

                                  <Col md="4" sm="6" className="my-2">
                                    <div className="cardCstm p-3 bg-white clint-profile-detail h-100 common-border-radius">
                                      <h6 className="m-0 themeBlue fw-bold">
                                        {" "}
                                        <span className="" style={{ color: "#3DA0AA" }}>
                                          ■
                                        </span>{" "}
                                        Total Attended Sessions
                                      </h6>
                                      <p className="m-0 themeBlue pt-3 lh-1 text-capitalize">{client?.totalpresent || "--"}</p>
                                    </div>
                                  </Col>


                                </Row>

                                <Row>
                                  <Col md="6" className="my-2">
                                    <div className="cardCstm p-3 bg-white clint-profile-detail group-leader-wrapper h-100">
                                      <h6 className="m-0 themeBlue fw-bold">
                                        {" "}
                                        <span className="" style={{ color: "#3DA0AA" }}>
                                          ■
                                        </span>{" "}
                                        Group Leader 1
                                      </h6>
                                      <div className=" d-flex gap-2 pt-3 imgWrp align-items-center flex-shrink-0">
                                        <img
                                          src={client?.program_head_one?.therapist_detail?.profile_picture || p1}
                                          alt=""
                                          className="img-fluid rounded-circle object-fit-cover"
                                          style={{ height: 30, width: 30 }}
                                        />
                                        <p className="m-0 themeBlue lh-1  text-capitalize">{client?.program_head_one ? userFullName(client?.program_head_one) : "--"}</p>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md="6" className="my-2">
                                    <div className="cardCstm p-3 bg-white clint-profile-detail group-leader-wrapper h-100">
                                      <h6 className="m-0 themeBlue fw-bold">
                                        {" "}
                                        <span className="" style={{ color: "#3DA0AA" }}>
                                          ■
                                        </span>{" "}
                                        Group Leader 2
                                      </h6>
                                      <div className=" d-flex gap-2 pt-3 imgWrp align-items-center flex-shrink-0">
                                        <img
                                          src={client?.program_head_two?.therapist_detail?.profile_picture || p1}
                                          alt=""
                                          className="img-fluid rounded-circle object-fit-cover"
                                          style={{ height: 30, width: 30 }}
                                        />
                                        <p className="m-0 themeBlue lh-1  text-capitalize">{client?.program_head_two ? userFullName(client?.program_head_two) : "--"}</p>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                          <Col lg="6" className="">
                            <Row>
                              <Col lg="12" className="my-2">
                                <div className="d-flex align-items-center justify-content-between flex-wrap gap-10">
                                  <h6 className="m-0 themeBlue fw-sbold">Track Attendence</h6>
                                </div>
                              </Col>
                              {/* <Col lg="12" className="my-2">
                                <p className="m-0 d-flex  align-items-center fw-sbold py-2">
                                  Event Date
                                </p>
                                <div
                                  className={`${styles.tableResponsive} tableResponsive table-responsive border rounded-2 mb-3 pb-0`}
                                >
                                  <table className={`${styles.table} table mb-0`}>
                                    {
                                      client?.attendance?.map((item, index) => {
                                        return <tbody>
                                          <tr onClick={() => setTableRow(tableRow == index ? null : index)}>
                                            <td className="">{convertToMomentDate(item?.session_date)}</td>

                                            <td className="">
                                              <Button
                                                className="border-0 p-0"
                                                variant="transparent"
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="20"
                                                  height="20"
                                                  viewBox="0 0 20 20"
                                                  fill="none"
                                                >
                                                  <path
                                                    d="M10 7.26925L6.4615 10.8078L13.5385 10.8078L10 7.26925ZM9.99825 0.500001C11.3122 0.500001 12.5473 0.749333 13.7035 1.248C14.8597 1.74667 15.8653 2.42342 16.7205 3.27825C17.5757 4.13308 18.2527 5.13833 18.7517 6.294C19.2506 7.44967 19.5 8.68442 19.5 9.99825C19.5 11.3123 19.2507 12.5473 18.752 13.7035C18.2533 14.8597 17.5766 15.8653 16.7217 16.7205C15.8669 17.5757 14.8617 18.2528 13.706 18.7518C12.5503 19.2506 11.3156 19.5 10.0017 19.5C8.68775 19.5 7.45267 19.2507 6.2965 18.752C5.14033 18.2533 4.13467 17.5766 3.2795 16.7218C2.42433 15.8669 1.74725 14.8617 1.24825 13.706C0.749416 12.5503 0.499999 11.3156 0.499999 10.0018C0.499999 8.68775 0.749331 7.45267 1.248 6.2965C1.74666 5.14033 2.42341 4.13467 3.27825 3.2795C4.13308 2.42433 5.13833 1.74725 6.294 1.24825C7.44966 0.749417 8.68442 0.500001 9.99825 0.500001ZM10 2C7.76666 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2Z"
                                                    fill="#071E3E"
                                                  />
                                                </svg>
                                              </Button>
                                            </td>
                                          </tr>
                                          {tableRow == index ? (
                                            <tr>
                                              <td colSpan={4} className="p-0 border-0">
                                                <div
                                                  className={`${styles.tableResponsive} tableResponsive table-responsive mb-0 pb-0`}
                                                >
                                                  <table className={`${styles.table} table mb-0`}>
                                                    <thead>
                                                      <tr className="">
                                                        <th className="text-dark fw-bold bg-transparent">
                                                          USERS
                                                        </th>
                                                        <th className="text-dark fw-bold bg-transparent">
                                                          PRESENT/ABSENT
                                                        </th>
                                                        {
                                                          data?.memberDetails?.client_detail?.client_type == "chatter" &&
                                                          <th className="text-dark fw-bold bg-transparent">
                                                            PARENT
                                                          </th>
                                                        }
                                                      </tr>
                                                    </thead>
                                                    {
                                                      client?.programMembers?.map((member, ind) => {

                                                        const userAttendance = item?.attendance?.find(x => x.member_id == member.id);
                                                        return <tbody key={ind}>
                                                          <tr>
                                                            <td className="border-0 p-2 text-capitalize">
                                                              {userFullName(member?.programMember)}
                                                            </td>
                                                            <td className="border-0 p-2">
                                                              <span>
                                                                {userAttendance?.attendance == "present" ? <PresentIcon /> : <AbsentIcon />}
                                                              </span>
                                                            </td>
                                                            {
                                                              data?.memberDetails?.client_detail?.client_type == "chatter" &&
                                                              <td className="border-0 p-2">
                                                                <td className="border-0 p-2">
                                                                  <span >
                                                                    {userAttendance?.with_parent == "yes" ? <PresentIcon /> : <AbsentIcon />}
                                                                  </span>
                                                                </td></td>
                                                            }
                                                          </tr>
                                                        </tbody>
                                                      })
                                                    }
                                                  </table>
                                                </div>
                                              </td>
                                            </tr>
                                          ) : null}
                                        </tbody>
                                      })
                                    }
                                  </table>
                                </div>
                              </Col> */}


                              <Col lg="12" className="my-2">
                                {/* <p className="m-0 d-flex align-items-center fw-sbold py-2">Event Date</p> */}
                                <div className={`${styles.tableResponsive} tableResponsive table-responsive border rounded-2 mb-3 pb-0`}>
                                  <table className={`${styles.table} table mb-0`}>
                                    <thead>
                                      <tr>
                                        <th className="text-dark fw-bold bg-transparent">Event Date</th>
                                        <th className="text-dark fw-bold bg-transparent">PRESENT</th>
                                        {data?.memberDetails?.client_detail?.client_type === "chatter" &&  client?.location_type == "community" && (
                                          <th className="text-dark fw-bold bg-transparent">PARENT</th>
                                        )}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {client?.attendance?.map((item, index) =>
                                        client?.programMembers?.map((member, ind) => {
                                          const userAttendance = item?.attendance?.find(x => x.member_id === member.id);
                                          return (
                                            <tr key={`${index}-${ind}`}>
                                              <td className="border-0 p-2 text-capitalize">
                                                {convertToMomentDate(item?.session_date) || "--"}
                                              </td>
                                              <td className="border-0 p-2">
                                                <span>
                                                  {userAttendance?.attendance === "present" ? <PresentIcon /> : <AbsentIcon />}
                                                </span>
                                              </td>
                                              {data?.memberDetails?.client_detail?.client_type === "chatter" &&  client?.location_type == "community" && (
                                                <td className="border-0 p-2">
                                                  <span>
                                                    {userAttendance?.with_parent === "yes" ? <PresentIcon /> : <AbsentIcon />}
                                                  </span>
                                                </td>
                                              )}
                                            </tr>
                                          );
                                        })
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Accordion.Body>
                    </Accordion.Item>
                  )
                }
              </Accordion>
            </Col>
          </Row>}
        </Container>
      </section>
    </>
  );
};

export default ChatterEventAttendanceDetail;

const PresentIcon = () => {
  return (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z"
      fill="#16BF12"
    />
  </svg>)
}

const AbsentIcon = () => {
  return (
    <svg
      width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_5342_36802" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5342_36802)">
        <path d="M12 21C10.7468 21 9.58226 20.763 8.49619 20.2943C7.39072 19.8173 6.43908 19.1749 5.63211 18.3679C4.82514 17.5609 4.18269 16.6093 3.70567 15.5038C3.23702 14.4177 3 13.2532 3 12C3 10.7468 3.23702 9.58226 3.70567 8.49619C4.18269 7.39072 4.82514 6.43908 5.63211 5.63211C6.43908 4.82514 7.39072 4.18269 8.49619 3.70567C9.58226 3.23702 10.7468 3 12 3C13.2532 3 14.4177 3.23702 15.5038 3.70567C16.6093 4.18269 17.5609 4.82514 18.3679 5.63211C19.1749 6.43908 19.8173 7.39072 20.2943 8.49619C20.763 9.58226 21 10.7468 21 12C21 13.2532 20.763 14.4177 20.2943 15.5038C19.8173 16.6093 19.1749 17.5609 18.3679 18.3679C17.5609 19.1749 16.6093 19.8173 15.5038 20.2943C14.4177 20.763 13.2532 21 12 21Z" fill="#ECECEC" stroke="#16BF12" stroke-width="2" />
      </g>
    </svg>
  )
}